import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs/";
import {
  AlertService,
  SectorOfEnterpriseService,
  AppService,
} from "../_services/index";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";

class SectorOfEnterprise {
  id: number;
  name: string;
  description: string;
  is_active: string;
}

@Component({
  selector: "app-sector-of-enterprise",
  templateUrl: "./sector-of-enterprise.component.html",
})
export class SectorOfEnterpriseComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [{ targets: [6], orderable: false }],
  };
  dtTrigger = new Subject();
  sectorofenterpriseList: SectorOfEnterprise[] = []; // Table Data list
  isSubmitted = false;
  // countryAddForm: FormGroup;
  getSectorofenterprise = {
    id: "",
    name: "",
    description: "",
    is_active: "N",
  };
  modalReference: NgbActiveModal;
  modalTitle: string;
  constructor(
    public router: Router,
    private dataService: SectorOfEnterpriseService,
    private alertService: AlertService,
    private AppService: AppService,
    private modalService: NgbModal
  ) {}
  sectorofenterprise = {
    id: "",
    name: "",
    description: "",
    is_active: "Y",
  };
  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scroll(0, 0);

    this.allSectorofenterprise();
  }

  allSectorofenterprise() {
    this.loadShow();
    this.dataService
      .getAllSectorofenterprise()
      .pipe()
      .subscribe((data) => {
        this.sectorofenterpriseList = data["sectorofenterprise"];
        this.rerender(); // Data Table
        this.loadHide();
      });
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  open(content) {
    if (this.getSectorofenterprise.id != null) {
      this.getSectorofenterprise.id = "";
    }
    this.isSubmitted = false;
    (this.sectorofenterprise.name = ""),
      (this.sectorofenterprise.description = ""),
      (this.sectorofenterprise.is_active = "Y");
    this.modalTitle = "Add Sector of enterprise";
    this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });
  }

  edit(id, content) {
    this.loadShow();
    this.dataService
      .getSectorofenterprise(id)
      .pipe()
      .subscribe((data) => {
        this.getSectorofenterprise = data["sectorofenterprise"];
        this.sectorofenterprise = {
          id: this.getSectorofenterprise.id,
          name: this.getSectorofenterprise.name,
          description: this.getSectorofenterprise.description,
          is_active: this.getSectorofenterprise.is_active,
        };
        this.loadHide();
        this.modalTitle = "Edit sector of enterprise";
        this.modalReference = this.modalService.open(content, {
          backdrop: "static",
          keyboard: false,
        });
      });
  }

  isFieldsInvalid(value: string): boolean {
    return !value || value.trim().length === 0;
  }

  save(val, f) {
    this.isSubmitted = true;
    this.isSubmitted = true;
    if (this.isFieldsInvalid(this.sectorofenterprise.name)) {
      return;
    }
    if (f.form.valid) {
      this.loadShow();
      if (val.id == "") {
        this.dataService
          .save(this.sectorofenterprise)
          .pipe()
          .subscribe(
            (data) => {
              if (data["status"] == 200) {
                this.loadHide();
                this.modalReference.close();
                this.alertService.success(
                  "Sector of enterprise saved successfully",
                  true
                );
                this.allSectorofenterprise();
              } else if (data["status"] == 422) {
                this.alertService.error(data.mesg.name);
                document
                  .querySelector(".modal")
                  .scrollTo({ top: 0, behavior: "smooth" });
                this.loadHide();
              } else {
                this.alertService.error("errors");
                document
                  .querySelector(".modal")
                  .scrollTo({ top: 0, behavior: "smooth" });
                this.loadHide();
              }
            },
            (error) => {
              this.loadHide();
              this.alertService.error(error);
              document
                .querySelector(".modal")
                .scrollTo({ top: 0, behavior: "smooth" });
            }
          );
      } else {
        this.dataService
          .sectorofenterpriseUpdate(this.sectorofenterprise)
          .pipe()
          .subscribe(
            (data) => {
              if (data["status"] == 200) {
                this.loadHide();
                this.modalReference.close();
                this.alertService.success(
                  "Sector of enterprise updated successfully",
                  true
                );
                this.allSectorofenterprise();
              } else if (data["status"] == 300) {
                this.loadHide();
                this.alertService.error(data.mesg);
                document
                  .querySelector(".modal")
                  .scrollTo({ top: 0, behavior: "smooth" });
              }
            },
            (error) => {
              this.loadHide();
              this.alertService.error(error);
              document
                .querySelector(".modal")
                .scrollTo({ top: 0, behavior: "smooth" });
            }
          );
      }
    }
  }

  delete(item) {
    this.loadShow();
    this.dataService
      .sectorofenterpriseDelete(item.id)
      .pipe()
      .subscribe(
        (data) => {
          if (data["status"] == 200) {
            this.alertService.success(
              "Sector of enterprise deleted successfully",
              true
            );
            item.is_active = item.is_active === "Y" ? "N" : "Y";
            this.allSectorofenterprise();
          } else {
            this.alertService.error("Sector of enterprise error");
          }
        },
        (error) => {
          this.alertService.error(error);
        }
      );
    this.loadHide();
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }
}
